export const analysisDimensions = [
  {
    label: '一级素材样式',
    key: 'dimImageStyle1Label',
    tableField: 'imageStyle1LabelNames',
    width: 100
  },
  {
    label: '二级素材样式',
    key: 'dimImageStyle2Label',
    tableField: 'imageStyle2LabelNames',
    width: 100,
    disabled: true
  },
  {
    label: '内容标签',
    key: 'dimContentLabel',
    tableField: 'labelNames',
    width: 70,
    disabled: true
  },
  // {
  //   label: '内容标签组',
  //   key: 'dimLabelGroup',
  //   tableField: 'labelGroupName',
  //   width: 70,
  //   disabled: true
  // },
  // {
  //   label: '营销主题标签',
  //   key: 'dimMarketingLabel',
  //   tableField: 'typeLabelNames',
  //   width: 100,
  //   disabled: true
  // },
  {
    label: '3D视频源',
    key: 'dimVideoLabel',
    tableField: 'videoLabelNames',
    width: 100,
    disabled: true
  }
]
